// Deep-link scheme registered by the Android/iOS projects (equals the Capacitor appId).
export const nativeAppScheme = "school.bgt.edubgt";

export function base64UrlEncode(bytes: Uint8Array) {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export async function createNativeLoginChallenge() {
  const verifier = base64UrlEncode(crypto.getRandomValues(new Uint8Array(48)));
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  return { verifier, challenge: base64UrlEncode(new Uint8Array(digest)) };
}

export function nativeLoginCallbackUrl(code: string) {
  return `${nativeAppScheme}://auth/callback?${new URLSearchParams({ code }).toString()}`;
}

export function appCallbackPathFromDeepLink(url: string) {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.protocol !== `${nativeAppScheme}:` || parsed.host !== "auth" || parsed.pathname !== "/callback") return null;
  const next = new URLSearchParams();
  const code = parsed.searchParams.get("code");
  const error = parsed.searchParams.get("error");
  if (code) next.set("code", code);
  if (error) next.set("error", error);
  return next.size ? `/auth/callback?${next.toString()}` : null;
}
